<div class="b-input__table">
  <div class="b-input__table-td b-input__table-td__dropdown">
    <label class="b-input__label" [innerHTML]="label" *ngIf="label" [for]="id" ></label>
      <select
      #sel
      [id]="id"
      [name]="name"
      class="b-input__input b-input__dropdown-input"
      [attr.disabled]="disabled ? true : undefined"
      (change)="selected($event)"

      (focus)="focused=true;wFocus.emit($event)"
      (blur)="focused=false;wBlur.emit($event)"
    >
      <option [style.display]="canUnselect && !noneSelected ? '':'none'" [selected]="noneSelected" [innerHTML]="unselectLabel"></option>
      <option
        *ngFor="let option of options"
        [selected]="isSelected(option)"
        [attr.title]="getTitle(option)"
        [ngValue]="getValue(option)"
        [innerHTML]="getLabelAsync(option) | async"
        [attr.disabled]="getDisabled(option)"
      >
      </option>
    </select>
  </div>
</div>

<f-facet-info [isError]="true">
  <ng-content select="f-facet[name=error],[facet-error]"></ng-content>
</f-facet-info>
<f-facet-info>
  <ng-content select="f-facet[name=info],[facet-info]"></ng-content>
</f-facet-info>
